import { Button, ButtonProps } from 'ui-components/common/Button';
import { Link } from 'ui-components/common/Link';
import { useClient } from 'ui-hooks/useClient';
import React from 'react';
import { useRequestSign } from 'ui-hooks/useRequestSign';
import { buildSignInUrl } from 'utils/url';
import { usePathname } from 'next/navigation';

export const SignLinkButton = ({ className, ...props }: ButtonProps) => {
  const client = useClient();
  const pathname = usePathname();
  const requestSign = useRequestSign();

  if (client.isApp) {
    return <Button onClick={requestSign} {...props} className={className} />;
  }

  return (
    <Link href={buildSignInUrl(pathname ?? '')} className={className}>
      <Button {...props} />
    </Link>
  );
};
